function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { constructFormData } from 'api/attachments/construct-form-data';
import { HttpClient } from 'api/http-client';
class CompanyHttpClient extends HttpClient {
    async updateCompany(companyId, data) {
        return this.put(`/companies/${companyId}`, data);
    }
    async createCompany(payload) {
        return this.post('/companies', payload);
    }
    async getAllCompanies() {
        return this.get('/companies');
    }
    /**
   * example: getCompanyLogoUrl('nike.com')
   * @param name
   */ async getCompanyLogoUrl(name) {
        return this.get('/companies/info', {
            params: {
                name
            }
        });
    }
    async uploadPicture(file) {
        const formData = constructFormData(file, {});
        return this.post('/companies/photo', formData);
    }
    async getCompanyAddresses(companyId, source) {
        return this.get(`/companies/${companyId}/address?source=${source}`);
    }
    getSpecificCompanyAddress(companyId, companyAddressId, source) {
        return this.get(`/companies/${companyId}/address/${companyAddressId}?source=${source}`);
    }
    async createAddress(companyId, payload) {
        return this.post(`/companies/${companyId}/address`, payload);
    }
    async editAddress(companyId, companyAddressId, payload) {
        return this.put(`/companies/${companyId}/address/${companyAddressId}`, payload);
    }
    async deleteAddress(companyId, companyAddressId) {
        return this.delete(`/companies/${companyId}/address/${companyAddressId}`);
    }
    constructor(...args){
        super(...args), _define_property(this, "exportAsCSV", (companyId, columnOrder)=>{
            return this.post(`reports/company-people/export?companyId=${companyId}`, {
                columnOrder
            }).then((response)=>response.downloadUrl);
        });
    }
}
export const CompanyAPI = new CompanyHttpClient();
